import {combineReducers} from "redux";
import loginReducer from "../../modules/auth/login/state/loginReducer";
import consultationPackagesReducer from "../../modules/packages/consultationPackages/state/consultationPackagesReducer";
import detailPackageReducer from "../../modules/packages/detailPackage/state/detailPackageReducer";
import modificationPackageReducer from "../../modules/packages/modificationPackage/state/modificationPackageReducer";
import nouveauPackageReducer from "../../modules/packages/nouveauPackage/state/nouveauPackageReducer";
import confirmerPaiementSouscriptionReducer
    from "../../modules/souscriptions/confirmerPaiementSouscription/state/confirmerPaiementSouscriptionReducers";
import consultationSouscriptionsReducer
    from "../../modules/souscriptions/consultationSouscriptions/state/consultationSouscriptionsReducer";
import detailsSouscriptionsReducer
    from "../../modules/souscriptions/detailsSouscription/state/detailsSouscriptionReducer";
import historySouscriptionsReducer
    from "../../modules/souscriptions/historiqueSouscription/state/historiqueSouscriptionReducer";
import modificationSouscriptionReducer
    from "../../modules/souscriptions/modificationSouscription/state/modificationSouscriptionReducer";
import nouvelleSouscriptionReducer
    from "../../modules/souscriptions/nouvelleSouscription/state/nouvelleSouscriptionReducer";
import paiementSouscriptionReducer
    from "../../modules/souscriptions/paiementSouscription/state/paiementSouscriptionReducer";
import consultationTransactionsReducer
    from "../../modules/transactions/consultationTransactions/state/consultationTransactionsReducer";
import localReferentielReducer from "../localReferentiel/state/localReferentielReducer";
import generalReducer from "./generalState/generalStateReducer";

const rootReducer = combineReducers({
  general: generalReducer,
  localReferentiel: localReferentielReducer,
  auth: combineReducers({
    login: loginReducer,
  }),
  packages: combineReducers({
    nouveauPackage: nouveauPackageReducer,
    modificationPackage: modificationPackageReducer,
    detailPackage: detailPackageReducer,
    consultationPackages: consultationPackagesReducer,
  }),
  transactions: combineReducers({
    consultationTransactions: consultationTransactionsReducer,
  }),
  souscription: combineReducers({
    nouvelleSouscription: nouvelleSouscriptionReducer,
    detailsSouscriptions: detailsSouscriptionsReducer,
    consultationSouscriptions: consultationSouscriptionsReducer,
    historySouscription: historySouscriptionsReducer,
    modificationSouscription: modificationSouscriptionReducer,
    confirmerPaiementSouscription: confirmerPaiementSouscriptionReducer,
    paiementSouscription: paiementSouscriptionReducer,
  }),
});

export default rootReducer;
